import { useState } from "react";
import { Photo } from "../types";
import PhotoFilter from "./PhotoFilter";
import { PhotoGrid } from "./PhotoGrid";

import { PhotoPreview } from "./PhotoPreview";
import { List, Pagination, PaginationProps } from "react-admin";

const PhotoPagination = (props: PaginationProps) => <Pagination rowsPerPageOptions={[25, 50, 100]} {...props} />;


export function PhotoList() {

    const [preview, setPreview] = useState<Photo>()
    const handleOnItemSelect = (photo: Photo) => {

        setPreview(photo)
    }

    return (
        <>
            <List
                sort={{ field: 'updatedAt', order: 'DESC' }}
                pagination={<PhotoPagination />}
                filters={<PhotoFilter />}
                filterDefaultValues={{ moderation: 'any', approved: false }}
                perPage={25}
                exporter={false}
            >
                <PhotoGrid onItemSelect={handleOnItemSelect} />
            </List>
            <PhotoPreview photo={preview} open={!!preview} onClose={() => setPreview(undefined)} />
        </>
    );
}




